<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>广告设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="listData" highlight-current-row
              v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60"></el-table-column>
      <el-table-column prop="id" label="ID" max-width="50"></el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="ad_img" label="图片" max-width="200">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.ad_img" :preview-src-list="[scope.row.ad_img]"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="ad_url" label="跳转地址"></el-table-column>
      <el-table-column sortable prop="sort" label="排序"></el-table-column>
      <el-table-column prop="channel_type" label="所属通道">
        <template slot-scope="scope">
          {{scope.row.channel_type == 'jsws' ? '锦胜雾森' : '凌阳高空'}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="display" label="是否启用" min-width="50">
        <template slot-scope="scope">
          <span v-if="scope.row.display == 0">否</span>
          <span v-else>是</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="adDeleted(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off"
                    placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="ad_img">
          <el-upload
            action="https://super.jinshengwusen.com/api/upload/store"
            list-type="picture-card"
            :on-success="completeUpload"
            :limit="1"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="跳转地址" prop="ad_url">
          <el-input size="small" v-model="editForm.ad_url" auto-complete="off"
                    placeholder="跳转地址"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input size="small" v-model="editForm.sort" auto-complete="off"
                    placeholder="排序"></el-input>
        </el-form-item>
        <el-form-item label="所属通道" prop="channel_type">
          <el-radio label="jsws" v-model="editForm.channel_type">锦胜雾森</el-radio>
          <el-radio label="lygk" v-model="editForm.channel_type">凌阳高空</el-radio>
        </el-form-item>
        <el-form-item label="是否启用" prop="display">
          <el-radio :label="1" v-model="editForm.display">是</el-radio>
          <el-radio :label="0" v-model="editForm.display">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {ad, adSave, adDelete} from '../../api/userMG'
  import Pagination from '../../components/Pagination'

  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        fileList: [],
        editForm: {
          ad_img: '',
          ad_url: '',
          sort: '',
          channel_type: 'jsws',
          display: 1
        },
        // rules表单验证
        rules: {
          ad_img: [
            {required: true, message: '请上传图片', trigger: 'blur'}
          ],
          permission: [
            {required: true, message: '请输入权限CODE', trigger: 'blur'}
          ]
        },
        formInline: {
          page: 1,
          limit: 10,
        },
        // 选择数据
        selectdata: [],
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    watch: {},

    /**
     * 创建完毕
     */

    created() {
      this.loading = true
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */

    methods: {
      // 获取数据方法
      getdata(parameter) {
        this.loading = false
        ad().then(res => {
          this.listData = res.data
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      completeUpload(response) {
        if (response.code == 0) {
          this.editForm.ad_img = response.url
        }
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        // 深拷贝并赋值
        if (row != undefined && row != 'undefined') {
          this.title = '修改'
          this.editForm.name = row.name
          this.editForm.ad_img = row.ad_img
          this.editForm.ad_url = row.ad_url
          this.editForm.sort = row.sort
          this.editForm.channel_type = row.channel_type
          this.editForm.display = row.display
          this.fileList.push({url: row.ad_img})
        } else {
          this.title = '添加'
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            adSave(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code == 200) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '广告管理保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('广告管理保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 删除权限
      adDeleted(row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          adDelete({id: row.id})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '广告已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: '广告删除失败'
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('广告删除失败,请稍后再试！')
            })
        })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 选择复选框事件
      selectChange(val) {
        this.selectdata = val
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/ad/index.vue